import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { SmallText, H5, Text } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import { FormattedMessage } from 'react-intl'
import { formatPrice } from 'shared/utils'
import { Stepper } from 'app/ecommerce/common/components'
import { Picture } from 'app/common/picture'
import { CheckOrRadio } from 'app/common/forms'
import { Checkbox, EmptyCircle, RadioChecked } from 'app/assets/icons'
import { Form, Formik } from 'formik'

const { crunchyGreenDisabled, crunchyGreen, grey } = colors

type Props = {
    id: string,
    name?: string,
    price?: number,
    noExtra?: boolean,
    imageUrl?: string,
    quantityInit?: number,
    quantityMax?: number,
    quantityMin?: number,
    onQuantityChange: (quantity: number) => void
}

type State = {
    currentQuantity: number
}

export class CatalogStepper extends Component<Props, State> {
    state: State = {
        currentQuantity: this.props.quantityInit ? this.props.quantityInit : 0
    }

    componentDidUpdate(prevProps: Props) {
        const { quantityInit } = this.props
        if (prevProps.quantityInit !== quantityInit) {
            this.setState({ currentQuantity: quantityInit })
        }
    }

    render() {
        const {
            id,
            name,
            price,
            imageUrl,
            quantityMax,
            quantityMin = 0,
            onQuantityChange,
            noExtra
        } = this.props
        const { currentQuantity } = this.state

        return (
            <Widget>
                <RowContainer>
                    <RowContainerCenter>
                        <ContainerImage>
                            {imageUrl && (
                                <Picture singleImage imageUrl={[imageUrl]} />
                            )}
                        </ContainerImage>
                        <TextContainer>
                            {name && <H5>{name}</H5>}

                            {!!price && (
                                <>
                                    {noExtra ? (
                                        <StyledSmallText>
                                            {formatPrice(price)}
                                        </StyledSmallText>
                                    ) : (
                                        price !== 0 && (
                                            <FormattedMessage
                                                id="clickandcollect.catalog.stepper.price"
                                                values={{
                                                    price:
                                                        price > 0
                                                            ? `+${formatPrice(
                                                                  price
                                                              )}`
                                                            : `-${formatPrice(
                                                                  price
                                                              )}`
                                                }}>
                                                {(text: string) => (
                                                    <StyledSmallText>
                                                        {text}
                                                    </StyledSmallText>
                                                )}
                                            </FormattedMessage>
                                        )
                                    )}
                                </>
                            )}
                        </TextContainer>
                    </RowContainerCenter>

                    <Stepper
                        value={currentQuantity}
                        colorLeft={
                            currentQuantity <= quantityMin
                                ? crunchyGreenDisabled
                                : crunchyGreen
                        }
                        colorRight={
                            quantityMax && currentQuantity >= quantityMax
                                ? crunchyGreenDisabled
                                : crunchyGreen
                        }
                        onPressLeft={() => {
                            if (currentQuantity > quantityMin) {
                                onQuantityChange(currentQuantity - 1)
                                this.setState({
                                    currentQuantity: currentQuantity - 1
                                })
                            }
                        }}
                        onPressRight={() => {
                            if (!quantityMax || currentQuantity < quantityMax) {
                                onQuantityChange(currentQuantity + 1)
                                this.setState({
                                    currentQuantity: currentQuantity + 1
                                })
                            }
                        }}
                    />
                </RowContainer>
            </Widget>
        )
    }
}

const Widget = styled.div`
    display: block;
    background-color: white;
    border-radius: 10px;
    margin: 5px;
    justify-content: center;
`

const ContainerImage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 70px;
`

const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px 15px;
`

const RowContainerCenter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
`

const TextContainer = styled.div`
    padding-left: 10px;
    display: flex;
    flex-direction: column;
`

const StyledSmallText = styled(SmallText)`
    color: ${grey};
`
